var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMOurVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 239,
    viewBox: "0 0 199 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.619 149.339C149.926 182.762 221.768 202.637 252.546 210.005C239.56 221.871 225.706 231.776 211.556 239.623C182.98 228.68 129.645 204.779 107.965 190.177C85.7681 175.228 72.4049 151.931 68.4258 131.361C63.3565 105.212 71.3317 83.5182 80.8285 68.1626C80.8484 68.1423 80.8583 68.1321 80.8682 68.1219C86.977 59.8149 93.8126 51.7409 101.366 44.0105C101.714 43.6545 102.052 43.3087 102.39 42.9629C101.023 44.809 55.8304 106.627 108.619 149.339Z",
    fill: "url(#paint0_linear_47_426)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3674 177.137C105.798 209.711 158.407 236.064 189.893 249.91C170.824 257.542 151.691 261.414 133.788 261.279C110.031 246.218 82.6912 227.397 69.7297 215.348C69.2518 214.901 68.774 214.454 68.3163 214.007C49.2051 195.432 41.4779 168.158 46.8276 142.049C51.4633 119.419 61.5701 95.9503 76.7613 73.8513C65.0697 92.4705 42.0676 139.168 76.3674 177.137Z",
    fill: "url(#paint1_linear_47_426)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.081 115.826C158.913 125.155 179.338 132.069 200.073 137.179C239.225 146.843 279.458 150.108 298.598 151.174C291.59 164.329 282.839 177.232 272.401 189.461C248.048 186.283 166.412 167.456 138.766 153.486C119.971 143.989 102.945 128.347 95.3468 108.714C92.0401 100.194 90.8585 91.9409 91.1501 84.1136C91.1501 84.1136 90.4952 43.1508 129.493 17.8297C130.251 17.298 130.902 17.0792 131.193 16.9451C126.501 23.4155 84.7229 84.017 142.081 115.806L142.081 115.826Z",
    fill: "url(#paint2_linear_47_426)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_426",
    x1: 176.079,
    y1: 196.148,
    x2: 154.981,
    y2: 24.7615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_426",
    x1: 138.881,
    y1: 218.296,
    x2: 109.013,
    y2: 56.6235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_426",
    x1: 211.645,
    y1: 159.447,
    x2: 177.643,
    y2: -18.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMOurVision);
export default __webpack_public_path__ + "static/media/mOurVision.a8395e275bf380331591d5cc15422577.svg";
export { ForwardRef as ReactComponent };